import React, { useState } from "react";
import ExpandableSection from "../../../../components/ExpandableSection";

export default function ProjectLocations(props) {

  var [expanded, setExpanded] = useState(true);

  return (
    <ExpandableSection
      title="Locations"
      buttonLabel="New Allocation"
      onButtonClick={function () {
        props.setShowMovePopup(true);
      }}
    >
      <div style={{ padding: "0 24px 24px 24px" }}>

        <div
          style={{
			marginTop:'40px',
            display: "grid",
            gridTemplateColumns: "80px 1fr",
            gap: "16px",
            alignItems: "flex-start"
          }}
        >

          {/* FLOW ARROW */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "28px",
              color: "#2F80ED",
              marginTop: "60px"
            }}
          >
            →
          </div>

          {/* DESTINATION */}
          <div>
            <div style={{ fontSize: "13px", color: "#666", marginBottom: "8px" }}>
              Destination
            </div>

            <div
              style={{
                background: "#f9fbff",
                border: "2px solid #2F80ED",
                borderRadius: "8px",
                padding: "16px",
                boxShadow: "0 6px 16px rgba(47,128,237,0.15)",
                maxWidth: "520px"
              }}
            >
              <div style={{ fontWeight: 600, color: "#2F80ED" }}>
                HQ Building
              </div>

              <div style={{ fontSize: "12px", color: "#666", marginBottom: "10px" }}>
                Destination building
              </div>

              {["Floor 1", "Floor 2"].map(function (floor) {
                return (
                  <div
                    key={floor}
                    style={{
                      background: "#ffffff",
                      borderRadius: "6px",
                      padding: "10px",
                      marginTop: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                    }}
                  >
                    <div style={{ fontWeight: 600 }}>{floor}</div>

                    {["Zone X", "Zone Y"].map(function (zone) {
                      return (
                        <div
                          key={zone}
                          style={{
                            fontSize: "13px",
                            marginTop: "6px",
                            display: "flex",
                            justifyContent: "space-between",
                            color: "#555"
                          }}
                        >
                          <span>{zone}</span>
                          <span>20 desks</span>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </ExpandableSection>
  );
}

